import { __ } from '@wordpress/i18n';
import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';
import Inspector from './InspectorControls';
import { getWrapperClasses, getWrapperStyles } from './styles';
import { getIconClasses } from '../../utils/helpers';
import './style.scss';

/**
 * Info Box — an icon, a heading, a line of text and a link.
 *
 * The icon belongs to this block (it is chrome, not prose, and the shaped
 * backdrop needs its size), while the words are core blocks: author-entered
 * static content gets core's full typography and colour controls for free.
 * Same split as Team Member.
 */

/**
 * Inserted with sample content rather than empty placeholders — an empty Info
 * Box is an unlabelled circle above two invisible paragraphs, and none of the
 * layout controls have anything to act on. Mirrors block.json's `example`.
 */
const TEMPLATE = [
  [
    'core/heading',
    {
      level: 3,
      content: __('Ships in two days', 'brandy-blocks'),
      placeholder: __('Title', 'brandy-blocks'),
      className: 'brandy-info-box__title',
    },
  ],
  [
    'core/paragraph',
    {
      content: __(
        'Order before three and it leaves the same afternoon, tracked the whole way.',
        'brandy-blocks'
      ),
      placeholder: __('Describe the feature', 'brandy-blocks'),
      className: 'brandy-info-box__text',
    },
  ],
];

export default function Edit({ attributes, setAttributes, clientId }) {
  const { iconName, iconType } = attributes;

  const blockProps = useBlockProps({
    className: getWrapperClasses(attributes),
    style: getWrapperStyles(attributes),
  });

  // Unlocked: a second paragraph, a button or a list are all reasonable
  // additions. The template is a starting point, not a cage.
  const innerBlocksProps = useInnerBlocksProps(
    { className: 'brandy-info-box__content' },
    {
      template: TEMPLATE,
      templateLock: false,
    }
  );

  const iconClasses = getIconClasses(iconName, iconType);

  return (
    <>
      <Inspector
        attributes={attributes}
        setAttributes={setAttributes}
        clientId={clientId}
      />

      <div {...blockProps}>
        {iconClasses && (
          <div className="brandy-info-box__media">
            <i className={iconClasses} aria-hidden="true" />
          </div>
        )}
        <div {...innerBlocksProps} />
      </div>
    </>
  );
}
